import React from "react";
import "./Policy.css";
import { staggerChildren, slideIn, fadeIn } from "../../utils/motion";
import { motion } from "framer-motion";

const Policy = () => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      variants={staggerChildren}
      viewport={{ once: false, amount: 0.25 }}
      className="policy-container"
    >
      <motion.div className="policy-section">
        <motion.h2
          variants={fadeIn("right", "tween", 0.5, 1.4)}
          className="policy-title"
        >
          Policy Overview
        </motion.h2>
        <motion.span
          variants={fadeIn("right", "tween", 0.5, 1.4)}
          style={{ fontWeight: "500", paddingBottom: "8px" }}
        >
          BetaHome.ng operates as a financial intermediary, connecting customers
          with accredited funding partners to facilitate furniture and interior
          decor purchases. Our policies ensure transparency, fairness, and
          compliance with financial regulations.
        </motion.span>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>
            Customer Eligibility: Buyers must meet credit assessment criteria
            set by funding partners.
          </li>
          <li>
            Vendor Partnerships: Only verified furniture vendors are onboarded
            to maintain quality and trust.
          </li>
          <li>
            Interest & Fees: Rates are disclosed upfront, with no hidden
            charges.
          </li>
          <li>
            Data Privacy: Customer and vendor information is secured under
            strict confidentiality protocols.
          </li>
        </motion.ul>
      </motion.div>
      <motion.div className="policy-section">
        <motion.h2
          variants={fadeIn("right", "tween", 0.5, 1.4)}
          className="policy-title"
        >
          Operational Framework
        </motion.h2>
        <motion.p>Financing Process</motion.p>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>
            Customers select betahome.ng flexpay packages or items from partner
            vendors.
          </li>
          <li>Funding partners conduct quick credit checks.</li>
          <li>
            Upon approval, the vendor receives full payment upfront, while the
            customer repays in 3–12 months with interest.
          </li>
        </motion.ul>

        <motion.p>Risk Management</motion.p>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>
            Funding partners assume repayment risk—vendors are paid immediately.
          </li>
          <li>
            Late payments incur penalties (clearly stated in loan agreements).
          </li>
        </motion.ul>
        <motion.span>Dispute Resolution</motion.span>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>Customer complaints are resolved within 5 business days.</li>
          <li>
            Vendor payment issues are escalated to the finance team for
            immediate resolution.
          </li>
        </motion.ul>
      </motion.div>
      <motion.div className="policy-section">
        <motion.h2
          variants={fadeIn("right", "tween", 0.5, 1.4)}
          className="policy-title"
        >
          Code of Conduct
        </motion.h2>
        <motion.span>For Customers:</motion.span>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>Provide accurate information during application.</li>
          <li>Repay loans as agreed to avoid penalties or legal action.</li>
          <li>Report fraudulent transactions immediately.</li>
        </motion.ul>

        <motion.span>For Vendors:</motion.span>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>Deliver quality products as advertised.</li>
          <li>Do not inflate prices for financed purchases.</li>
          <li>Comply with anti-fraud and anti-money laundering policies..</li>
        </motion.ul>
        <motion.span>For Funding Partners</motion.span>
        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>Adhere to ethical lending practices.</li>
          <li>Disclose all terms (APR, fees, penalties) before approval.</li>
          <li>No discrimination based on gender, ethnicity, or religion.</li>
        </motion.ul>
      </motion.div>
      <motion.div className="policy-section">
        <motion.h2
          variants={fadeIn("right", "tween", 0.5, 1.4)}
          className="policy-title"
        >
          Compliance & Ethics
        </motion.h2>

        <motion.ul
          variants={slideIn("up", "tween", 0.5, 1.4)}
          className="policy-list"
        >
          <li>
            Regulatory Adherence: All transactions comply with Nigeria’s Central
            Bank guidelines on consumer lending.
          </li>
          <li>
            Anti-Fraud Measures: Fraudulent applications lead to blacklisting
            and legal action.
          </li>
          <li>
            Transparency: All fees, repayment schedules, and penalties are
            communicated in writing.
          </li>
          <li>
            Violations? Report to: admin@betahome.ng BetaHome.ng is committed to
            fair, secure, and convenient financing for all stakeholders.
          </li>
        </motion.ul>
      </motion.div>
    </motion.div>
  );
};

export default Policy;
